// This file is auto-generated by the generateModuleTranslationKeys Vite plugin.
// Do not edit this file manually.
import { createModuleTranslationsRuntime } from "@/shared/culture/moduleTranslations";
import { TranslationModule } from "./translationModules.generated";

export const { ModuleTranslationsContext, useTranslationModule } = createModuleTranslationsRuntime<TranslationModule>();
